<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="شكر-وتقدير">
<p><span dir="rtl"><br/>
</span></p>
<p style="text-indent:0px;"><span dir="rtl">أُرِيدُ حَيَاةً تكونُ كَما أُرِيدُهَا...</span></p>
<p><span dir="rtl">أُرِيدُ حَيَاةَ نَجَاحٍ وتعلمٍ وَنُمُوّ...</span></p>
<p><span dir="rtl">أُرِيدُ حَيَاةَ فَهْمٍ وَمَعْرِفَة...</span></p>
<p><span dir="rtl">أُرِيدُ اَلْحَقِيقَة وَالْكَمَال...</span></p>
<p><span dir="rtl">أُرِيدُ أن أستيقظ كَلَّ صباحٍ مفعماً بِالطَّاقَة</span> <span dir="rtl">والحَيَويةِ</span> <span dir="rtl">والإقبالِ عَلى الحَيَاة...</span></p>
<p><span dir="rtl">أُرِيدُ أن يَقُولَ كُلّ مَنْ يُقَابِلنِي بَعْدهَا، إنَّ رُؤيَتي لمَبْعَثٌ لِلْفَرَحِ وَالطَّاقَةِ الإيجابيةِ...</span></p>
<p><span dir="rtl">أُرِيدُ أن يُؤْسَفَ حَقاً على مُغَادَرَتي هَذهِ الحَيَاةِ في حِينهَا وَيُقال: لقد خَسِرَتْهُ البَشَرية...</span></p>
<p><span dir="rtl">أُرِيدُ حَيَاةً تكونُ كَما أُرِيدُهَا...</span></p>
<p><span dir="rtl">هَيا اِنْهَـــضْ</span>!</p>
<p style="text-align: center;"><strong><span dir="rtl">الشَّمْس حِينُ تُشرِقُ تَكُونُ لَنا نَحْنُ في الأرض دِفْئاً وَنُوراً، وَالحَقِيقَةَ مَا إنْ تُشرِقُ تَكُون لَنا حَيَاة</span>.</strong></p>
<p style="text-align: center;"><strong><span dir="rtl">وَالحَياةُ ما هي بِجَوهَرِها إلا للفخر رداً للامْتِنَان.</span></strong></p>
<p><span dir="rtl">تحية إلى جميع العقول المقاتلة في الحياة، أينما كانت من أي شعب كان وبأي أرضٍ حلَّت، تلك العقول التي يُعَوِّلُ العالَم على صنيعها في تقدمه وآماله، ويستبشر منها البناء والمستقبل الأفضل.</span></p>
<p><span dir="rtl">هي عقولٌ تُشحَنُ من تلقاء نفسها، متخذةً قرارها بوعيٍ أن تختارَ كل ما يدفعها لِحُبّ الحياةِ ورغبةٍ عميقةٍ بإضافة الشيء الجديد إلى الإنسانية. هؤلاء هم من يقولون لأنفسهم باستمرار دون كللٍ أو ملل: " <strong>اِنْهَـــضْ! أريد حياة تكون كما أريدها".</strong></span></p>
<br/>
<p style="text-align: center;"><strong><span dir="rtl">في الحياة وهي أعظم نعمة وتجربة مُنَّ علينا بها من الله، أقولها وهي لي للأبدية...</span></strong></p>
<br/>
<p><span dir="rtl">الفخر هو أشد رغبة.. والامتنان هو قمة المتعة...</span></p>
<p><span dir="rtl">الإيمان هو أضمن الأفعال.. والإبداع هو أوج التميز...</span></p>
<p><span dir="rtl">الابتهاج هو أجمل حضور.. والسكينة هي خير ما يمكن نشره...</span></p>
<p><span dir="rtl">الحب هو أعلى الولاء... والفهم هو دعامة الأمل...</span></p>
<p><span dir="rtl">الشغف هو وقود السعادة.. والمعرفة هي أجمل مسيرة...</span></p>
<p><span dir="rtl">التوسع هو أهم هدف.. والإنجاز هو أعمق حاجة...</span></p>
<p><span dir="rtl">الاستهتار هو أخطر مغامرة.. والجهل هو أصل كُلِّ الشرور...</span></p>
<p><span dir="rtl">الربيع هو للزيادة.. والصيف هو للتمتع وتقاسم الثمار...</span></p>
<p><span dir="rtl">الخريف هو انتقال الأحداث</span> <span dir="rtl">والتغيُّر.. وأمّا الشتاء فهو للزراعة وتأمل الأفكار.</span></p>
<p><span dir="rtl">وهكذا حتى زوال العالم.</span></p><br/>
<p style="text-align: left;"><span dir="rtl">ليـــث حجـازيـن.</span></p>
<br/>
<p><span dir="rtl">ناكرٌ ومغيبٌ وغاضبٌ وضائعٌ، لكن فجأة وبعد أن مضى من عمري 35 عاماً، من اللا وجهة، والخلو من المعنى ومن تتالي خيبات الأمل، صَرخَ ذاك الصوت الداخلي وقال لي: " <strong>اِنْهَـــضْ</strong>! <strong>اِنْهَـــضْ</strong> <strong>يـا بنـي</strong>! <strong>هيـا</strong> <strong>اِنْهَـــضْ</strong>! <strong>فقد</strong> <strong>حان وقتـك</strong>".</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?e6d6882a